import { render, staticRenderFns } from "./UpdatePrices.vue?vue&type=template&id=fa56b7aa&scoped=true&"
import script from "./UpdatePrices.vue?vue&type=script&lang=js&"
export * from "./UpdatePrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa56b7aa",
  null
  
)

export default component.exports